import PropTypes from 'prop-types'
import { IconButton } from '@chakra-ui/react'

export const NormalIconButton = ({ icon, p = '0px', width = '37px', height = '37px', minW = '28px', ...props }) => {
  return <IconButton variant="outline" icon={icon} p={p} width={width} height={height} minW={minW} {...props} />
}

NormalIconButton.propTypes = {
  icon: PropTypes.object.isRequired,
}
